import { useCallback } from "react";
import Loan from "typedef/Loan";
import API from "utils/API";

const useTWNVerification = () => {
  const getTWNIncome = useCallback(async (isBorrower: boolean, loan: Loan) => {
    const borrowerData =
      process.env.REACT_APP_ENV === "prod"
        ? {
            ssn: isBorrower
              ? loan?.borrowerSteps?.idVerification?.socialSecurityNumber
              : loan?.coborrowerSteps?.idVerification?.socialSecurityNumber,
          }
        : {
            ssn: isBorrower ? "666190810" : "799005075",
          };

    const result = await API.post({
      url: "/invoke",
      data: {
        FunctionName: "getTheWorkNumberReportDoor",
        InvocationType: "RequestResponse",
        Service: "nftydoor-core",
        Payload: {
          loanId: loan.id,
          borrowerData,
          isBorrower: isBorrower ?? false,
          options: {
            purpose: "PPCREDIT",
            templateName: "AutoGold",
            employeeStatusFilter: "B",
            generatePDF: true,
          },
        },
      },
    });

    return result;
  }, []);

  return { getTWNIncome };
};

export default useTWNVerification;
